import * as React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { TeaserCardCollageItem } from './Item/item'
import { TeaserCardCollageProps } from './types'
import 'swiper/css'
import { TitleWithPrefix } from '../../components/UI/TitleWithPrefix'
import { sbEditable } from '@storyblok/storyblok-editable'
import {
  TeaserCardCollageContainer,
  TeaserCardCollageGrid,
  TeaserCardCollageGridItem,
  TeaserCardCollageHeader,
  TeaserCardCollageSlider,
  TeaserCardCollageSliderInner,
  TeaserCardCollageWrapper,
} from './styled'

export const TeaserCardCollage = ({ blok }: TeaserCardCollageProps) => {
  const hasAlternativeLayout = blok.items.length % 4 === 1 || blok.items.length % 4 === 3

  return (
    <TeaserCardCollageWrapper {...sbEditable(blok)}>
      <TeaserCardCollageContainer>
        {blok.headline && (
          <TeaserCardCollageHeader>
            <TitleWithPrefix
              title={blok.headline}
              prefix={blok.prefixLine}
              headlineSize={blok.headlineSize}
              headlineType={blok.headlineSyntax}
            />
          </TeaserCardCollageHeader>
        )}
        <TeaserCardCollageGrid alternativeLayout={hasAlternativeLayout}>
          {blok.items.map((item, i) => (
            <TeaserCardCollageGridItem key={item._uid}>
              <TeaserCardCollageItem blok={item} index={i} showStep={blok.showSteps} />
            </TeaserCardCollageGridItem>
          ))}
        </TeaserCardCollageGrid>
      </TeaserCardCollageContainer>
      <TeaserCardCollageSlider>
        <TeaserCardCollageSliderInner>
          <Swiper>
            {blok.items.map((item, i) => (
              <SwiperSlide key={item._uid}>
                <TeaserCardCollageItem blok={item} index={i} showStep={blok.showSteps} />
              </SwiperSlide>
            ))}
          </Swiper>
        </TeaserCardCollageSliderInner>
      </TeaserCardCollageSlider>
    </TeaserCardCollageWrapper>
  )
}
